require ("./pvplib/Behavior.js");
require ("./pvplib/require.js");
require ("./pvplib/PVPGEngine.html.js");
require ("./fragment/Tabs.js");
require ("./fragment/Dropdown.js");

require ("./pvplib/Template.js");
require ("./fragment/Popup.js");
require ("./pvplib/PVPGEngine.debugExt.js");
require ("./pvplib/Data.js");

require ("./pvplib/ArrayData.js");
require ("./fragment/HommageData.js");

var delayJs = import(/* webpackChunkName: "notif.delay" */ "./notif.delay");